<!DOCTYPE html>
<html>
	<head>
		<meta charset="utf-8">
		<title>Login</title>
		<style>
		.login-form {
			width: 300px;
			margin: 0 auto;
			font-family: Tahoma, Geneva, sans-serif;
		}
		.login-form h1 {
			text-align: center;
			color: #4d4d4d;
			font-size: 24px;
			padding: 20px 0 20px 0;
		}
		.login-form input[type="password"],
		.login-form input[type="text"] {
			width: 100%;
			padding: 15px;
			border: 1px solid #dddddd;
			margin-bottom: 15px;
			box-sizing:border-box;
		}
		.login-form input[type="submit"] {
			width: 100%;
			padding: 15px;
			background-color: #535b63;
			border: 0;
			box-sizing: border-box;
			cursor: pointer;
			font-weight: bold;
			color: #ffffff;
		}
		</style>
	</head>
	<body>
		<div class="login-form" *ngIf="state == 'none' || state == 'error'">
			<h1>Login Form</h1>
				<input type="text" [(ngModel)]="username" placeholder="Username" required [ngModelOptions]="{standalone: true}">
				<input type="password" [(ngModel)]="password" placeholder="Password" required [ngModelOptions]="{standalone: true}">
				<button (click)="login()">Submit</button>
		</div>

		<div *ngIf="state == 'logged_in'">
			Welcome {{username}}
		</div>

		<div *ngIf="state == 'logging_in'">
			Logging in...
		</div>
	</body>
</html>
